module.exports = __webpack_public_path__ + "img/qualityIndexScore3.4ea4cf43.png";